/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleAddClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";

const AddTrials = ({ userData }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();

  //! get trials list api
  const { refetch, data: allTrialsDetails = [] } = useQuery({
    queryKey: ["allTrialsDetails"],
    queryFn: async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/trial`);
      const data = await res.json();
      return data.data;
    },
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("trial_name", data.trialName);
    formData.append("description", data.trialDescription);
    formData.append("active_flag", "1");
    formData.append("created_by", userData?.id);

    fetch(`${process.env.REACT_APP_API_URL}/api/trial`, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.meta.duplicate === false) {
          toast.success("Trial Add successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
          refetch().then(() => {
            dispatch(handleAddClose());
          });
        } else if (data.meta.duplicate === true) {
          toast.error("This Trial is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
          reset()
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* trial name */}
      <Box p="20px">
        <TextField
          size="small"
          fullWidth
          label="Trial Name*"
          variant="outlined"
          {...register("trialName", { required: true })}
        />
        {errors?.study_code?.type === "required" && (
          <ErrorMessage>Trial name is required*</ErrorMessage>
        )}
      </Box>

      {/* trial description */}
      <Box p=" 0 20px 20px 20px">
        <TextField
          size="small"
          fullWidth
          label="Trial Description*"
          variant="outlined"
          {...register("trialDescription", { required: true })}
        />
        {errors?.protocol_title?.type === "required" && (
          <ErrorMessage>Trial description is required*</ErrorMessage>
        )}
      </Box>

      {/* add button */}
      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton style={{}} type="submit">
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton style={{}} type="submit">
            Add Trial
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </Box>
    </form>
  );
};

export default AddTrials;
